import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@material-ui/core";
import styled from "styled-components/macro";
import { useSelector } from "react-redux";
import {
  getAllProducts,
  getProductsBySpecies,
  selectSaleProgressSaleLots,
} from "selectors";
import { getBestMatchingProductId } from "lib/products";
import {
  AttributeTable,
  groupSaleLots,
} from "./SaleProgressTotalsAttributeTable";

const ScrollableAccordionDetails = styled(AccordionDetails)`
  overflow-x: scroll;
`;

interface SaleProgressProductTotalsAccordionProps {
  square?: boolean;
}

export function SaleProgressProductTotalsAccordion(
  props: SaleProgressProductTotalsAccordionProps,
): React.JSX.Element {
  const { square = false } = props;

  const name = "Products";

  const saleLots = useSelector(selectSaleProgressSaleLots) || [];
  const saleSpeciesProducts = useSelector(getProductsBySpecies);
  const productByIdLookup = useSelector(getAllProducts);

  const attributeGroups = groupSaleLots(
    saleLots,
    (saleLot: SaleLot) =>
      getBestMatchingProductId(saleLot, saleSpeciesProducts),
    productId =>
      productId !== "null"
        ? `${productByIdLookup[productId].name} (${productByIdLookup[productId].quick_code})`
        : "Other",
  );

  const expandIcon = <FontAwesomeIcon icon={faCaretDown} size="sm" />;

  return (
    <Accordion square={square}>
      <AccordionSummary
        id={`${name.toLowerCase()}-panel-header`}
        expandIcon={expandIcon}
      >
        <span className="font-bold">{name}</span>
      </AccordionSummary>
      <ScrollableAccordionDetails>
        <AttributeTable attributeGroups={attributeGroups} name={name} />
      </ScrollableAccordionDetails>
    </Accordion>
  );
}
